/* PackageEditorComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PackageEditorRenderer");
const PackageSummary = require("../../lib/PackageSummaryMixin");

const _ = require("lodash");
_.mixin(require("underscore.string").exports());

class PackageEditorComponent extends PackageSummary(EventEmitter) {
    constructor(
        userSession,
        logger,
        registrationDetails,
        HubbyService,
        editorState,
        magicBus,
        steveIO
    ) {
        super();
        this._userSession = userSession;
        this._logger = logger;
        this._hubbyService = HubbyService;
        this._magicBus = magicBus;
        this._fileFactory = steveIO.fileFactory;
        this._registrationDetails = registrationDetails;
        this._editorState = _.get(editorState, "editorState");
        this._launchOpts = _.get(editorState, "launchOptions");

        //Setup private variable used by the PackageSummary Mixin
        this._pkgSummary = _.get(this._editorState, "resource");

        this._renderer = new Renderer(this);

        this._registerListeners();

        if (_.get(this._editorState, "tab")) {
            this.setEditorMode(this._editorState.tab, true);
        }
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this.renderer._shutdown().then(() => {
            this._steve = undefined;
            this._logger = undefined;
            this._hubbyService = undefined;
            this._renderer = undefined;
            this._registrationDetails = undefined;
            this._hubbyService = undefined;
            this._editorState = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START EDITOR METHODS */
    /*******************************************/
    resizeContainer(width, height) {
        this.emit("ResizeContainer", width, height);
    }
    /*******************************************/
    /* END EDITOR METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*** Editor State ***/
    get editorState() {
        return this.getEditorState();
    }
    getEditorState() {
        return this._editorState;
    }
    setEditorState(newState) {
        this._editorState = newState;
        if (_.get(newState, "tab")) {
            this.setEditorMode(this._editorState.tab);
        }
    }
    /*** Editor Mode ***/
    get editorMode() {
        return this.getEditorMode();
    }
    getEditorMode() {
        return _.get(this.editorState, "editorMode", "general");
    }
    set editorMode(m) {
        return this.setMode(m);
    }
    setEditorMode(m, silent) {
        let old = _.cloneDeep(this.editorMode);
        //TODO validate options and hook into Golden Layout
        _.set(this.editorState, "editorMode", m);
        if (!silent) {
            this.emit("EditorModeChanged", this.editorMode, old);
        }
        return this;
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /* START PUBLIC API ACTION METHODS */
    /*******************************************/
    installPackage(callbacks) {
        let orgId = _.get(this._userSession, "activeOrganization.id");
        let repoId = this.repoId;
        let packageId = this.remotePkgId;
        if (!packageId) {
            callbacks.Failure({error: "Package is no longer available for installation"});
            return;
        }
        this._hubbyService.packageInstall(
            {
                orgId: orgId,
                repoId: repoId,
                packageId: packageId,
                packageName: this.remotePkgDetails.name,
                packageVersion: _.get(this.remotePkgDetails, "semVersion"),
                previousPackageVersion: _.get(this.localPkgDetails, "semVersion"),
            },
            {
                Success: (results) => {
                    //TODO HACK ALERT
                    this._magicBus.emit("PackageInstalled", results, this._pkgSummary);
                    this._pkgSummary.local = _.cloneDeep(this._pkgSummary.remote);
                    this._pkgSummary.diff = "Same";
                    this.emit("PackageInstalled");
                    if (_.isFunction(_.get(callbacks, "Success"))) {
                        callbacks.Success(results);
                    }
                },
                Progress: (msg) => {
                    if (_.isFunction(_.get(callbacks, "Progress"))) {
                        callbacks.Progress(msg);
                    }
                },
                Failure: (error) => {
                    if (_.isFunction(_.get(callbacks, "Failure"))) {
                        callbacks.Failure(error);
                    }
                },
            }
        );
    }
    previewPackage(callbacks) {
        let orgId = _.get(this._userSession, "activeOrganization.id");
        let repoId = this.repoId;
        let packageId = this.remotePkgId;
        if (!packageId) {
            callbacks.Failure({error: "Package is no longer available for installation"});
            return;
        }
        this._hubbyService.packageInstallPreview(
            {
                orgId: orgId,
                repoId: repoId,
                packageId: packageId,
            },
            {
                Success: (results) => {
                    if (_.isFunction(_.get(callbacks, "Success"))) {
                        callbacks.Success(results);
                    }
                },
                Progress: (msg) => {
                    if (_.isFunction(_.get(callbacks, "Progress"))) {
                        callbacks.Progress(msg);
                    }
                },
                Failure: (error) => {
                    if (_.isFunction(_.get(callbacks, "Failure"))) {
                        callbacks.Failure(error);
                    }
                },
            }
        );
    }
    exportPackage(callbacks) {
        let orgId = _.get(this._userSession, "activeOrganization.id");
        let repoId = this.repoId;
        let packageId = this.remotePkgId;
        if (!packageId) {
            callbacks.Failure({error: "Package is no longer available for installation"});
            return;
        }
        this._hubbyService.packageExport(
            {
                orgId: orgId,
                repoId: repoId,
                packageId: packageId,
            },
            {
                Success: (results) => {
                    //TODO HACK ALERT
                    this._magicBus.emit("PackageExport", results, this._pkgSummary);
                    this._pkgSummary.local = _.cloneDeep(this._pkgSummary.remote);
                    this._pkgSummary.diff = "Same";
                    this.emit("PackageExport");
                    if (_.isFunction(_.get(callbacks, "Success"))) {
                        let fileName = this.getName() + "_pkg";
                        this._fileFactory.saveStringsAsZip(results.pkgContent, fileName);
                        callbacks.Success(results);
                    }
                },
                Progress: (msg) => {
                    if (_.isFunction(_.get(callbacks, "Progress"))) {
                        callbacks.Progress(msg);
                    }
                },
                Failure: (error) => {
                    if (_.isFunction(_.get(callbacks, "Failure"))) {
                        callbacks.Failure(error);
                    }
                },
            }
        );
    }
    downloadLog(callbacks, contents, fileName) {
        try {
            this._fileFactory.saveStringAsFile(contents, `${fileName}.log`);
            callbacks.Success("Log downloaded successfully");
        } catch (err) {
            console.error("(PackageEditorComponent) downloadLog Error: " + err);
            callbacks.Failure({error: "Failed to download log"});
        }
    }
    /*******************************************/
    /* END PUBLIC API ACTION METHODS */
    /*******************************************/
}
PackageEditorComponent.$inject = [
    "$teve.userSession",
    "$teve.logger",
    "$teve.registeredDetails",
    "$teve.services.Hubby",
    "editorLayout.editorState",
    "$teve.magicBus",
    "$teve.io",
];

module.exports = PackageEditorComponent;
PackageEditorComponent.$editorIcon = "slnman.package";
PackageEditorComponent.$editorIconType = "base-icon-gl";
